import type { ResultadoPedidos, FiltroPedidos } from "../../../services/dadosPedidoFornecedor"

export enum DadosPedidoFornecedorActionsTypes {
    DEFINIR_FILTRO = "DEFINIR_FILTRO",
    CARREGAR_RESULTADO = "CARREGAR_RESULTADO",
    SET_PAGINA = "SET_PAGINA",
}

type DefinirFiltroAction = {
    type: DadosPedidoFornecedorActionsTypes.DEFINIR_FILTRO
    payload: Partial<FiltroPedidos>
}

type CarregarResultadoAction = {
    type: DadosPedidoFornecedorActionsTypes.CARREGAR_RESULTADO
    payload: ResultadoPedidos
}

type SetPaginaAction = {
    type: DadosPedidoFornecedorActionsTypes.SET_PAGINA
    payload: number
}

export type DadosPedidoFornecedorActions =
    | DefinirFiltroAction
    | CarregarResultadoAction
    | SetPaginaAction
